import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { useFreeProxyData } from "../../../../../store/freeProxy/freeProxy.selectors";

import {
  PaginationItemStyled,
  PaginationStyled,
  Wrapper,
} from "./Pagination.styled";

export const Pagination = () => {
  const { paginationData } = useFreeProxyData();
  const [searchParams, setSearchParams] = useSearchParams();

  const pageFromParams = Number(searchParams.get("page"));
  const [currentPage, setCurrentPage] = useState(pageFromParams || 1);

  useEffect(() => {
    if (pageFromParams) {
      setCurrentPage(pageFromParams);
    }
  }, [pageFromParams]);

  const getPage = data => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("page", data);
    setSearchParams(params.toString());
  };

  const handleChangePage = (event, page) => {
    getPage(page);
    setCurrentPage(page);
  };

  return (
    <Wrapper>
      <PaginationStyled
        page={currentPage}
        onChange={handleChangePage}
        count={paginationData?.totalPages}
        shape="rounded"
        renderItem={item => <PaginationItemStyled {...item} />}
      />
    </Wrapper>
  );
};
